import { render, staticRenderFns } from "./discussSetting.vue?vue&type=template&id=e24251f2&scoped=true&"
import script from "./discussSetting.vue?vue&type=script&lang=js&"
export * from "./discussSetting.vue?vue&type=script&lang=js&"
import style0 from "./discussSetting.vue?vue&type=style&index=0&id=e24251f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24251f2",
  null
  
)

export default component.exports